import React from 'react'
import { host } from '../../utils/globals';

export default ({ team, isEnglish }) => {
    return (<div className="white-bckg district-contact">
        <div className="container">
            <div className="row">
                <div className="col-xs-12">
                    <div className="district-title">
                        <h1>district team contact details</h1>
                    </div>

                    <div className="row">
                        {team && Array.isArray(team) && team.slice(0, 4).map(d => (
                                <div className="col-xs-12 col-sm-3" key={d.id}>
                                    <div className="circle-thumbnail">
                                        {/*<figure>*/}
                                            {/*<a href="#">*/}
                                                {/*<img*/}
                                                    {/*src={*/}
                                                        {/*d.image_path*/}
                                                            {/*? `${host}${d.image_path}`*/}
                                                            {/*: "http://via.placeholder.com/150x150"*/}
                                                    {/*}*/}
                                                    {/*alt={d.name}*/}
                                                    {/*className="img-circle"*/}
                                                {/*/>*/}
                                            {/*</a>*/}
                                        {/*</figure>*/}
                                        <h1>{isEnglish ? d.name : d.nepali_name}</h1>
                                        <p>{isEnglish ? d.position : d.position_nepali}</p>
                                        <a href={`mailto:${d.email}`}>{d.email}</a>
                                        <p>{d.phone}</p>
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
}
